const reg = /<[^<^>]*?>/g;
const regScript = /[jJ][aA][vV][aA][sS][cC][rR][iI][pP][tT]:/g;

// html标签嵌套的情况下会绕过正则表达式，所以需要递归的匹配。如：<<xx>a href="javascript:alert(111)">11</a >
export default function removeHTMLTag(str) {
  if (reg.test(str)) {
    const res = str.replace(reg, '');
    return removeHTMLTag(res);
  }
  return str;
}

// 去除'javascript:'的字符
export function removeHTMLScript(str) {
  if (regScript.test(str)) {
    return str.replace(regScript, '');
  }
  return str;
}
